import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'; 
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'; 

import { ensureChartkick } from '../chartkick_config'

function replaceUnassignedInnerFromHtml(htmlString) {
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');
  const next = doc.getElementById('unassigned-participants-inner');
  const cur = document.getElementById('unassigned-participants-inner');
  if (next && cur) {
    cur.replaceWith(next);
  }
}

function updateUnassignedCounter() {
  const mount = document.getElementById('unassigned-participants-mount');
  if (!mount) return;
  const n = mount.querySelectorAll("input[name='participant_ids[]']:checked").length;
  mount.querySelectorAll('.unassigned-counter').forEach((el) => {
    el.textContent = String(n);
  });
}

function initUnassignedParticipantsAjax() {
  const mount = document.getElementById('unassigned-participants-mount');
  if (!mount || mount.dataset.bound === '1') return;
  mount.dataset.bound = '1';
  const baseUrl = mount.dataset.fetchUrl;

  function fetchUnassigned(url) {
    return fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'text/html',
      },
      credentials: 'same-origin',
    }).then((r) => r.text());
  }

  mount.addEventListener('submit', (e) => {
    if (e.target && e.target.id === 'unassigned-search-form') {
      e.preventDefault();
      const fd = new FormData(e.target);
      const qs = new URLSearchParams(fd).toString();
      const url = qs ? `${baseUrl}?${qs}` : baseUrl;
      fetchUnassigned(url).then((html) => {
        replaceUnassignedInnerFromHtml(html);
        updateUnassignedCounter();
      });
    }
  });

  mount.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a || !mount.contains(a)) return;
    const inPaginate = a.closest('.unassigned-pagination');
    if (!inPaginate && !a.classList.contains('js-unassigned-reset')) return;
    e.preventDefault();
    fetchUnassigned(a.href).then((html) => {
      replaceUnassignedInnerFromHtml(html);
      if (a.classList.contains('js-unassigned-reset')) {
        const form = document.getElementById('unassigned-search-form');
        if (form) form.reset();
      }
      updateUnassignedCounter();
    });
  });

  $(document).on('change', '#unassigned-check-all', function unassignedCheckAll() {
    const inner = document.getElementById('unassigned-participants-inner');
    if (!inner) return;
    inner.querySelectorAll("input[name='participant_ids[]']").forEach((cb) => {
      cb.checked = this.checked;
    });
    updateUnassignedCounter();
  });

  $(document).on('change', '#unassigned-participants-mount input[name="participant_ids[]"]', () => {
    updateUnassignedCounter();
  });

  updateUnassignedCounter();
}

function updateExamSessionCheckAllState() {
  const master = document.getElementById('exam-session-check-all');
  if (!master) return;
  const rowChecks = document.querySelectorAll('.exam-session-row-check');
  if (rowChecks.length === 0) {
    master.checked = false;
    master.indeterminate = false;
    return;
  }
  const n = Array.from(rowChecks).filter((cb) => cb.checked).length;
  master.checked = n === rowChecks.length;
  master.indeterminate = n > 0 && n < rowChecks.length;
}

function initExamSessionsBulkCheckboxes() {
  $(document).on('change', '#exam-session-check-all', function examSessionCheckAll() {
    const on = this.checked;
    document.querySelectorAll('.exam-session-row-check').forEach((cb) => {
      cb.checked = on;
    });
    updateExamSessionCheckAllState();
  });

  $(document).on('change', '.exam-session-row-check', () => {
    updateExamSessionCheckAllState();
  });
}

function examSessionsFetchTimestampLabel() {
  const d = new Date()
  return (
    'Terakhir sinkron dari server: '
    + d.toLocaleString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })
  )
}

function updateExamDataFetchStatus() {
  const el = document.getElementById('exam-data-fetch-status')
  if (el) el.textContent = examSessionsFetchTimestampLabel()
}

function initExamSessionsTablePoll() {
  const mount = document.getElementById('exam-sessions-table-mount')
  if (!mount || mount.dataset.tablePollBound === '1') return
  mount.dataset.tablePollBound = '1'
  const baseUrl = mount.dataset.tablePollUrl
  const intervalMs = parseInt(mount.dataset.tablePollMs || '30000', 10)
  if (!baseUrl || !intervalMs) return

  function fetchTableHtml() {
    const qs = window.location.search || ''
    const url = qs ? `${baseUrl}${qs}` : baseUrl
    return fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'text/html',
      },
      credentials: 'same-origin',
    }).then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`)
      return r.text()
    })
  }

  function pollTableFragment() {
    fetchTableHtml()
      .then((html) => {
        mount.innerHTML = html
        updateExamDataFetchStatus()
        updateExamSessionCheckAllState()
      })
      .catch(() => {})
  }

  // Sinkron pertama segera (grafik sudah fetch di awal); lalu sama seperti interval Chartkick (~30 detik).
  pollTableFragment()
  setInterval(pollTableFragment, intervalMs)
}

const EXAMS_OVERVIEW_STORAGE = 'examsOverviewChartIds'

function examsOverviewReadIds() {
  try {
    const raw = sessionStorage.getItem(EXAMS_OVERVIEW_STORAGE)
    const parsed = raw ? JSON.parse(raw) : []
    const arr = Array.isArray(parsed) ? parsed : []
    // Samakan bentuk dengan data-exam-id (string); JSON bisa menyimpan number.
    return [...new Set(arr.map((id) => String(id)))]
  } catch (e) {
    return []
  }
}

function examsOverviewWriteIds(ids) {
  sessionStorage.setItem(EXAMS_OVERVIEW_STORAGE, JSON.stringify(ids))
}

function persistExamChartSelectionFromCheckbox(cb) {
  const id = cb.dataset.examId
  if (!id) return
  let ids = examsOverviewReadIds()
  if (cb.checked) {
    if (!ids.includes(id)) ids.push(id)
  } else {
    ids = ids.filter((x) => x !== id)
  }
  examsOverviewWriteIds(ids)
}

function setupExamsIndexSharedChartListeners() {
  if (typeof window !== 'undefined' && window.__examsIndexSharedChartListeners) return
  if (typeof window !== 'undefined') window.__examsIndexSharedChartListeners = true

  document.addEventListener('change', (e) => {
    const onPage = document.getElementById('exams-charts-overview-root')
      || document.getElementById('exams-participants-answers-root')
    if (!onPage) return

    const t = e.target
    if (!t || !t.classList) return

    if (t.classList.contains('js-exam-chart-select')) {
      persistExamChartSelectionFromCheckbox(t)
      if (typeof window.__examsIndexRefreshLocationCharts === 'function') {
        window.__examsIndexRefreshLocationCharts()
      }
      if (typeof window.__examsIndexRefreshPaCharts === 'function') {
        window.__examsIndexRefreshPaCharts()
      }
    }
    if (t.classList.contains('js-exams-chart-mode')
      && typeof window.__examsIndexRefreshLocationCharts === 'function') {
      window.__examsIndexRefreshLocationCharts()
    }
    if (t.classList.contains('js-exams-pa-mode')
      && typeof window.__examsIndexRefreshPaCharts === 'function') {
      window.__examsIndexRefreshPaCharts()
    }
  })
}

function examsOverviewChartOptions() {
  return {
    height: '300px',
    stacked: false,
    colors: ['#6c757d', '#ffc107', '#28a745'],
    library: {
      plugins: { legend: { display: true, position: 'bottom' } },
      scales: {
        x: { stacked: false },
        y: { stacked: false, beginAtZero: true, ticks: { precision: 0 } },
      },
    },
  }
}

function examOverviewChartkick () {
  return ensureChartkick()
}

function destroyExamOverviewCharts() {
  const Ck = examOverviewChartkick()
  if (!Ck || !Ck.charts) return
  Object.keys(Ck.charts).slice().forEach((key) => {
    if (key.startsWith('examso-')) {
      try {
        Ck.charts[key].destroy()
      } catch (e) {
        /* ignore */
      }
    }
  })
}

function examOverviewHasSeriesData(series) {
  if (!series || !Array.isArray(series)) return false
  return series.some((s) => s && s.data && typeof s.data === 'object' && Object.keys(s.data).length > 0)
}

function renderExamOverviewCharts(payload) {
  const host = document.getElementById('exams-overview-charts-host')
  if (!host) return

  destroyExamOverviewCharts()
  host.innerHTML = ''

  const Ck = examOverviewChartkick()
  if (!Ck || typeof Ck.ColumnChart !== 'function') {
    host.innerHTML = '<p class="text-danger text-center">Grafik tidak tersedia: Chartkick tidak termuat dari pack application. Lakukan hard refresh (Ctrl+F5) atau rebuild assets.</p>'
    return
  }

  if (!payload || payload.error) {
    const msg = (payload && payload.error) ? payload.error : 'Gagal memuat data.'
    host.innerHTML = `<p class="text-muted text-center mb-0">${msg}</p>`
    return
  }

  const opts = examsOverviewChartOptions()

  if (payload.mode === 'merged') {
    const series = payload.series || []
    const h = document.createElement('h6')
    h.className = 'text-center mb-2'
    h.textContent = payload.title || 'Gabungan ujian terpilih'
    host.appendChild(h)
    if (!examOverviewHasSeriesData(series)) {
      const p = document.createElement('p')
      p.className = 'text-muted text-center mb-0'
      p.textContent = 'Belum ada data sesi / lokasi untuk ujian terpilih.'
      host.appendChild(p)
      return
    }
    const div = document.createElement('div')
    div.id = 'examso-merged'
    div.style.height = '320px'
    host.appendChild(div)
    try {
      // eslint-disable-next-line no-new
      new Ck.ColumnChart('examso-merged', series, opts)
    } catch (err) {
      host.innerHTML = `<p class="text-danger text-center">Grafik gagal digambar: ${err.message || err}</p>`
    }
  } else {
    const charts = payload.charts || []
    if (!charts.length) {
      host.innerHTML = '<p class="text-muted text-center mb-0">Tidak ada data.</p>'
      return
    }
    charts.forEach((ch, i) => {
      const wrap = document.createElement('div')
      wrap.className = 'mb-4 pb-3 border-bottom'
      const h = document.createElement('h6')
      h.className = 'text-center mb-2'
      h.textContent = ch.title || String(ch.exam_id)
      wrap.appendChild(h)
      host.appendChild(wrap)

      const series = ch.series || []
      if (!examOverviewHasSeriesData(series)) {
        const p = document.createElement('p')
        p.className = 'text-muted text-center small mb-0'
        p.textContent = 'Belum ada data untuk ujian ini.'
        wrap.appendChild(p)
        return
      }

      const div = document.createElement('div')
      div.id = `examso-sep-${i}`
      div.style.height = '280px'
      wrap.appendChild(div)
      try {
        // eslint-disable-next-line no-new
        new Ck.ColumnChart(`examso-sep-${i}`, series, opts)
      } catch (err) {
        const pe = document.createElement('p')
        pe.className = 'text-danger text-center small'
        pe.textContent = err.message || String(err)
        wrap.appendChild(pe)
      }
    })
  }
}

function updateExamsOverviewFetchStatus() {
  const el = document.getElementById('exams-overview-fetch-status')
  if (!el) return
  el.textContent = examSessionsFetchTimestampLabel()
}

function examsOverviewPayloadSignature(json) {
  if (!json || json.error) return `e:${String(json && json.error)}`
  try {
    return JSON.stringify(json)
  } catch (err) {
    return `x:${Date.now()}`
  }
}

function examOverviewChartsHostHasCharts(host) {
  if (!host) return false
  return host.querySelector('canvas, [id^="examso-"]') != null
}

function participantsAnswersBarHeightPx(payload) {
  let n = 0
  if (!payload || payload.error) return 280
  if (payload.mode === 'merged') {
    const s = payload.series && payload.series[0]
    n = s && s.data ? Object.keys(s.data).length : 0
  } else {
    (payload.charts || []).forEach((ch) => {
      const s = ch.series && ch.series[0]
      n += s && s.data ? Object.keys(s.data).length : 0
    })
  }
  return Math.min(2000, Math.max(200, 72 + n * 28))
}

function examsPaChartOptions(payload, scoresByLabel = {}) {
  const h = `${participantsAnswersBarHeightPx(payload)}px`
  const scores = scoresByLabel && typeof scoresByLabel === 'object' ? scoresByLabel : {}
  return {
    height: h,
    stacked: true,
    colors: ['#28a745', '#0d6efd'],
    library: {
      plugins: {
        legend: { display: true, position: 'bottom' },
        datalabels: {
          anchor: 'end',
          align: 'end',
          offset: 2,
          color: '#212529',
          font: { weight: '600', size: 10 },
          formatter: (value) => {
            const v = Number(value)
            if (!Number.isFinite(v) || v === 0) return ''
            return String(v)
          },
        },
        tooltip: {
          callbacks: {
            afterBody: (items) => {
              if (!items || items.length === 0) return []
              const item = items[0]
              const labels = item.chart.data.labels
              const rowLabel = labels[item.dataIndex]
              const raw = scores[rowLabel]
              const scoreStr = raw === null || raw === undefined ? '—' : String(raw)
              return [`Nilai (score): ${scoreStr}`]
            },
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          beginAtZero: true,
          ticks: { precision: 0 },
          title: { display: true, text: 'Jumlah jawaban (bertumpuk)' },
        },
        y: {
          stacked: true,
          ticks: { autoSkip: false },
        },
      },
    },
  }
}

function destroyExamParticipantsAnswersCharts() {
  const Ck = examOverviewChartkick()
  if (!Ck || !Ck.charts) return
  Object.keys(Ck.charts).slice().forEach((key) => {
    if (key.startsWith('examspa-')) {
      try {
        Ck.charts[key].destroy()
      } catch (e) {
        /* ignore */
      }
    }
  })
}

function renderExamParticipantsAnswersCharts(payload) {
  const host = document.getElementById('exams-participants-answers-charts-host')
  if (!host) return

  destroyExamParticipantsAnswersCharts()
  host.innerHTML = ''

  const Ck = examOverviewChartkick()
  if (!Ck || typeof Ck.BarChart !== 'function') {
    host.innerHTML = '<p class="text-danger text-center">Grafik tidak tersedia (Chartkick BarChart).</p>'
    return
  }

  if (!payload || payload.error) {
    const msg = (payload && payload.error) ? payload.error : 'Gagal memuat data.'
    host.innerHTML = `<p class="text-muted text-center mb-0">${msg}</p>`
    return
  }

  const appendTruncNote = (wrap, truncated, shown, total, chartLimit) => {
    if (!truncated) return
    const lim = chartLimit || 200
    const p = document.createElement('p')
    p.className = 'text-warning small text-center mb-2'
    p.textContent = `Menampilkan ${shown} peserta terbanyak jawaban (dari ${total} peserta). Batas tampilan ${lim} baris per grafik.`
    wrap.appendChild(p)
  }

  if (payload.mode === 'merged') {
    const series = payload.series || []
    const wrap = document.createElement('div')
    host.appendChild(wrap)
    const h = document.createElement('h6')
    h.className = 'text-center mb-2'
    h.textContent = payload.title || 'Gabungan ujian terpilih'
    wrap.appendChild(h)
    appendTruncNote(wrap, payload.truncated, payload.shown, payload.total_participants, payload.chart_limit)

    if (!examOverviewHasSeriesData(series)) {
      const p = document.createElement('p')
      p.className = 'text-muted text-center mb-0'
      p.textContent = 'Belum ada jawaban terisi untuk ujian terpilih.'
      wrap.appendChild(p)
      return
    }

    const div = document.createElement('div')
    div.id = 'examspa-merged'
    div.style.height = `${participantsAnswersBarHeightPx(payload)}px`
    wrap.appendChild(div)
    try {
      const opts = examsPaChartOptions(payload, payload.scores_by_label)
      // eslint-disable-next-line no-new
      new Ck.BarChart('examspa-merged', series, opts)
    } catch (err) {
      host.innerHTML = `<p class="text-danger text-center">Grafik gagal digambar: ${err.message || err}</p>`
    }
  } else {
    const charts = payload.charts || []
    if (!charts.length) {
      host.innerHTML = '<p class="text-muted text-center mb-0">Tidak ada data.</p>'
      return
    }
    charts.forEach((ch, i) => {
      const wrap = document.createElement('div')
      wrap.className = 'mb-4 pb-3 border-bottom'
      const h = document.createElement('h6')
      h.className = 'text-center mb-2'
      h.textContent = ch.title || String(ch.exam_id)
      wrap.appendChild(h)
      host.appendChild(wrap)
      appendTruncNote(wrap, ch.truncated, ch.shown, ch.total_participants, ch.chart_limit)

      const series = ch.series || []
      if (!examOverviewHasSeriesData(series)) {
        const p = document.createElement('p')
        p.className = 'text-muted text-center small mb-0'
        p.textContent = 'Belum ada jawaban terisi untuk ujian ini.'
        wrap.appendChild(p)
        return
      }

      const singlePayload = { mode: 'merged', series, truncated: false }
      const div = document.createElement('div')
      div.id = `examspa-sep-${i}`
      div.style.height = `${participantsAnswersBarHeightPx(singlePayload)}px`
      wrap.appendChild(div)
      try {
        const opts = examsPaChartOptions(singlePayload, ch.scores_by_label)
        // eslint-disable-next-line no-new
        new Ck.BarChart(`examspa-sep-${i}`, series, opts)
      } catch (err) {
        const pe = document.createElement('p')
        pe.className = 'text-danger text-center small'
        pe.textContent = err.message || String(err)
        wrap.appendChild(pe)
      }
    })
  }
}

function updateExamsParticipantsAnswersFetchStatus() {
  const el = document.getElementById('exams-participants-answers-fetch-status')
  if (!el) return
  el.textContent = examSessionsFetchTimestampLabel()
}

function examsPaPayloadSignature(json) {
  if (!json || json.error) return `e:${String(json && json.error)}`
  try {
    return JSON.stringify(json)
  } catch (err) {
    return `x:${Date.now()}`
  }
}

function examPaChartsHostHasCharts(host) {
  if (!host) return false
  return host.querySelector('canvas, [id^="examspa-"]') != null
}

function initExamsParticipantsAnswersOverview() {
  const root = document.getElementById('exams-participants-answers-root')
  if (!root || root.dataset.paBound === '1') return
  root.dataset.paBound = '1'

  setupExamsIndexSharedChartListeners()

  const urlBase = root.dataset.chartsUrl
  const intervalMs = parseInt(root.dataset.pollMs || '15000', 10)

  function selectedMode() {
    const sel = root.querySelector('.js-exams-pa-mode:checked')
    return sel && sel.value === 'merged' ? 'merged' : 'separate'
  }

  function fetchParticipantsAnswers(opts = {}) {
    const { isPoll = false } = opts
    const ids = examsOverviewReadIds()

    if (ids.length === 0) {
      root.dataset.lastPaSig = ''
      destroyExamParticipantsAnswersCharts()
      const host = document.getElementById('exams-participants-answers-charts-host')
      if (host) {
        const hasRows = root.dataset.hasExamRows === '1'
        const msg = hasRows
          ? '<p class="text-muted text-center mb-0">Centang ujian pada kolom <strong>Grafik</strong> di tabel (sama seperti grafik lokasi di atas).</p>'
          : '<p class="text-muted text-center mb-0">Tidak ada baris ujian; reset filter atau buka halaman <kbd>/dashboard</kbd>.</p>'
        host.innerHTML = msg
      }
      const st = document.getElementById('exams-participants-answers-fetch-status')
      if (st) st.textContent = ''
      return Promise.resolve()
    }

    const hostEl = document.getElementById('exams-participants-answers-charts-host')
    const keepChartsVisible = examPaChartsHostHasCharts(hostEl)

    if (!keepChartsVisible) {
      destroyExamParticipantsAnswersCharts()
      if (hostEl) {
        hostEl.innerHTML = '<p class="text-muted text-center mb-0">Memuat grafik…</p>'
      }
    }

    const params = new URLSearchParams()
    ids.forEach((id) => params.append('exam_ids[]', id))
    params.set('mode', selectedMode())

    return fetch(`${urlBase}?${params.toString()}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((r) => r.json().catch(() => ({})).then((json) => ({ ok: r.ok, status: r.status, json })))
      .then(({ ok, status, json }) => {
        if (!ok) {
          renderExamParticipantsAnswersCharts(json.error ? json : { error: `Gagal memuat (${status})` })
          root.dataset.lastPaSig = ''
          updateExamsParticipantsAnswersFetchStatus()
          return
        }
        const sig = examsPaPayloadSignature(json)
        if (isPoll && sig === root.dataset.lastPaSig) {
          updateExamsParticipantsAnswersFetchStatus()
          return
        }
        root.dataset.lastPaSig = sig
        renderExamParticipantsAnswersCharts(json)
        updateExamsParticipantsAnswersFetchStatus()
      })
      .catch(() => {
        if (!isPoll || !keepChartsVisible) {
          renderExamParticipantsAnswersCharts({ error: 'Tidak dapat menghubungi server.' })
        }
        updateExamsParticipantsAnswersFetchStatus()
      })
  }

  window.__examsIndexRefreshPaCharts = () => fetchParticipantsAnswers()

  fetchParticipantsAnswers()
  setInterval(() => {
    if (document.hidden) return
    fetchParticipantsAnswers({ isPoll: true })
  }, intervalMs)
}

function seedExamsOverviewDefaultIds(root) {
  if (!root || examsOverviewReadIds().length > 0) return
  const raw = root.dataset.defaultExamIds || ''
  const defaults = raw.split(',').map((s) => s.trim()).filter(Boolean)
  if (defaults.length) examsOverviewWriteIds(defaults)
}

function initExamsChartsOverview() {
  const root = document.getElementById('exams-charts-overview-root')
  if (!root || root.dataset.overviewBound === '1') return
  root.dataset.overviewBound = '1'

  seedExamsOverviewDefaultIds(root)
  setupExamsIndexSharedChartListeners()

  const urlBase = root.dataset.chartsUrl
  const intervalMs = parseInt(root.dataset.pollMs || '15000', 10)

  function restoreCheckboxes() {
    const ids = examsOverviewReadIds()
    document.querySelectorAll('.js-exam-chart-select').forEach((cb) => {
      if (cb.dataset.examId) cb.checked = ids.includes(cb.dataset.examId)
    })
  }

  function selectedMode() {
    const sel = root.querySelector('.js-exams-chart-mode:checked')
    return sel && sel.value === 'merged' ? 'merged' : 'separate'
  }

  function fetchOverview(opts = {}) {
    const { isPoll = false } = opts
    const ids = examsOverviewReadIds()

    if (ids.length === 0) {
      root.dataset.lastOverviewSig = ''
      destroyExamOverviewCharts()
      const host = document.getElementById('exams-overview-charts-host')
      if (host) {
        const hasRows = root.dataset.hasExamRows === '1'
        const msg = hasRows
          ? '<p class="text-muted text-center mb-0">Centang minimal satu ujian pada kolom <strong>Grafik</strong> di tabel di bawah; atau pakai tombol <strong>Pilih semua di halaman ini</strong>.</p>'
          : '<p class="text-muted text-center mb-0"><strong>Tidak ada baris ujian ditampilkan</strong>. Reset filter di halaman <kbd>/dashboard</kbd>.</p>'
        host.innerHTML = msg
      }
      const st = document.getElementById('exams-overview-fetch-status')
      if (st) st.textContent = ''
      return Promise.resolve()
    }

    const hostEl = document.getElementById('exams-overview-charts-host')
    const keepChartsVisible = examOverviewChartsHostHasCharts(hostEl)

    // Hindari placeholder "Memuat grafik…" saat polling / refresh cepat — itu mengosongkan area,
    // konten di bawah ikut melompat. Hanya tampilkan loading pada muat pertama (belum ada chart).
    if (!keepChartsVisible) {
      destroyExamOverviewCharts()
      if (hostEl) {
        hostEl.innerHTML = '<p class="text-muted text-center mb-0">Memuat grafik…</p>'
      }
    }

    const params = new URLSearchParams()
    ids.forEach((id) => params.append('exam_ids[]', id))
    params.set('mode', selectedMode())

    return fetch(`${urlBase}?${params.toString()}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((r) => r.json().catch(() => ({})).then((json) => ({ ok: r.ok, status: r.status, json })))
      .then(({ ok, status, json }) => {
        if (!ok) {
          renderExamOverviewCharts(json.error ? json : { error: `Gagal memuat (${status})` })
          root.dataset.lastOverviewSig = ''
          updateExamsOverviewFetchStatus()
          return
        }
        const sig = examsOverviewPayloadSignature(json)
        if (isPoll && sig === root.dataset.lastOverviewSig) {
          updateExamsOverviewFetchStatus()
          return
        }
        root.dataset.lastOverviewSig = sig
        renderExamOverviewCharts(json)
        updateExamsOverviewFetchStatus()
      })
      .catch(() => {
        if (!isPoll || !keepChartsVisible) {
          renderExamOverviewCharts({ error: 'Tidak dapat menghubungi server.' })
        }
        updateExamsOverviewFetchStatus()
      })
  }

  window.__examsIndexRefreshLocationCharts = () => fetchOverview()

  restoreCheckboxes()
  fetchOverview()
  setInterval(() => {
    if (document.hidden) return
    fetchOverview({ isPoll: true })
  }, intervalMs)

  const btnPage = document.getElementById('exams-chart-select-page')
  if (btnPage) {
    btnPage.addEventListener('click', () => {
      let ids = examsOverviewReadIds()
      document.querySelectorAll('.js-exam-chart-select').forEach((cb) => {
        cb.checked = true
        const id = cb.dataset.examId
        if (id && !ids.includes(id)) ids.push(id)
      })
      examsOverviewWriteIds(ids)
      fetchOverview()
      if (typeof window.__examsIndexRefreshPaCharts === 'function') {
        window.__examsIndexRefreshPaCharts()
      }
    })
  }

  const btnClear = document.getElementById('exams-chart-clear-selection')
  if (btnClear) {
    btnClear.addEventListener('click', () => {
      examsOverviewWriteIds([])
      document.querySelectorAll('.js-exam-chart-select').forEach((cb) => {
        cb.checked = false
      })
      fetchOverview()
      if (typeof window.__examsIndexRefreshPaCharts === 'function') {
        window.__examsIndexRefreshPaCharts()
      }
    })
  }
}

function isPenyeliaRoleValue(val) {
  return val === 'penyelia' || val === '4' || Number(val) === 4
}

function escapeHtml(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function commandCenterTimestampLabel(iso) {
  try {
    const d = iso ? new Date(iso) : new Date()
    if (Number.isNaN(d.getTime())) return examSessionsFetchTimestampLabel()
    return `Diperbarui ${d.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}`
  } catch (e) {
    return examSessionsFetchTimestampLabel()
  }
}

function renderCommandCenterKpis(host, kpis) {
  if (!host || !kpis) return
  const items = [
    ['exams_aktif', 'Ujian aktif', ''],
    ['total', 'Total peserta', ''],
    ['hadir', 'Hadir', 'text-success'],
    ['tidak_hadir', 'Tidak hadir', 'text-danger'],
    ['mengerjakan', 'Mengerjakan', 'text-primary'],
    ['waktu_habis', 'Waktu habis (belum selesai)', 'text-danger'],
    ['selesai', 'Selesai', 'text-success'],
    ['belum_mulai', 'Belum mulai', 'text-secondary'],
    ['idle', 'Nonaktif (idle)', 'text-warning'],
    ['rapid', 'Cepat jawab', 'text-danger'],
  ]
  host.innerHTML = items.map(([key, label, klass]) => `
    <div class="col-6 col-md-4 col-xl-3 mb-2">
      <div class="card border-0 shadow-sm h-100">
        <div class="card-body py-3">
          <div class="text-muted small">${label}</div>
          <div class="h4 mb-0 font-weight-bold ${klass}" data-kpi="${key}">${Number(kpis[key] || 0)}</div>
        </div>
      </div>
    </div>`).join('')
}

function renderCommandCenterBoard(host, rows) {
  if (!host) return
  if (!rows || !rows.length) {
    host.innerHTML = '<div class="col-12"><div class="alert alert-light border mb-0">Tidak ada ujian aktif untuk filter ini.</div></div>'
    return
  }

  host.innerHTML = rows.map((row) => {
    const warn = (Number(row.idle) > 0 || Number(row.rapid) > 0 || Number(row.waktu_habis) > 0)
      ? ' border-left border-warning'
      : ''
    const overdueBadge = Number(row.waktu_habis) > 0
      ? `<span class="badge badge-danger">Habis ${Number(row.waktu_habis)}</span>`
      : ''
    const idleBadge = Number(row.idle) > 0
      ? `<span class="badge badge-warning">Idle ${Number(row.idle)}</span>`
      : ''
    const rapidBadge = Number(row.rapid) > 0
      ? `<span class="badge badge-danger">Cepat ${Number(row.rapid)}</span>`
      : ''
    const sesiUjian = row.exam_sessions_url
      ? `<a href="${escapeHtml(row.exam_sessions_url)}" target="_blank" rel="noopener" class="btn btn-sm btn-outline-info">Sesi Ujian</a>`
      : ''
    const monitor = row.monitor_url
      ? `<a href="${escapeHtml(row.monitor_url)}" target="_blank" rel="noopener" class="btn btn-sm btn-outline-primary">Monitor</a>`
      : ''
    const aktif = row.active_sessions_url
      ? `<a href="${escapeHtml(row.active_sessions_url)}" target="_blank" rel="noopener" class="btn btn-sm btn-outline-secondary">Detail aktif</a>`
      : ''
    const absen = row.absence_url && Number(row.tidak_hadir) > 0
      ? `<a href="${escapeHtml(row.absence_url)}" target="_blank" rel="noopener" class="font-weight-bold text-danger">${Number(row.tidak_hadir)}</a>`
      : `<div class="font-weight-bold text-danger">${Number(row.tidak_hadir || 0)}</div>`
    return `
      <div class="col-lg-6 col-xl-4 mb-3">
        <div class="card border-0 shadow-sm h-100${warn}">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div class="pr-2">
                <div class="font-weight-bold">${escapeHtml(row.exam_name)}</div>
                <div class="text-muted small">${escapeHtml(row.lokasi)}</div>
                ${row.batch_sesi_label ? `<div class="text-muted small">${escapeHtml(row.batch_sesi_label)}</div>` : ''}
                <div class="text-muted small" title="${escapeHtml(row.jadwal_title || '')}"><i class="far fa-clock"></i> ${escapeHtml(row.jadwal_label || '-')}</div>
              </div>
              <div class="text-right text-nowrap">${overdueBadge} ${idleBadge} ${rapidBadge}</div>
            </div>
            <div class="d-flex text-center small mb-3">
              <div class="flex-fill px-1"><div class="text-muted">Hadir</div><div class="font-weight-bold">${Number(row.hadir || 0)}</div></div>
              <div class="flex-fill px-1"><div class="text-muted">Absen</div>${absen}</div>
              <div class="flex-fill px-1"><div class="text-muted">Belum</div><div class="font-weight-bold text-secondary">${Number(row.belum_mulai || 0)}</div></div>
              <div class="flex-fill px-1"><div class="text-muted">Kerja</div><div class="font-weight-bold text-primary">${Number(row.mengerjakan || 0)}</div></div>
              <div class="flex-fill px-1"><div class="text-muted">Habis</div><div class="font-weight-bold text-danger">${Number(row.waktu_habis || 0)}</div></div>
              <div class="flex-fill px-1"><div class="text-muted">Selesai</div><div class="font-weight-bold text-success">${Number(row.selesai || 0)}</div></div>
            </div>
            <div class="text-right">${sesiUjian} ${monitor} ${aktif}</div>
          </div>
        </div>
      </div>`
  }).join('')
}

function initCommandCenter() {
  const root = document.getElementById('command-center-root')
  if (!root || root.dataset.ccBound === '1') return
  root.dataset.ccBound = '1'

  const urlBase = root.dataset.dataUrl
  const intervalMs = parseInt(root.dataset.pollMs || '15000', 10)
  const statusEl = document.getElementById('command-center-fetch-status')
  const kpisHost = document.getElementById('command-center-kpis')
  const boardHost = document.getElementById('command-center-board')

  function buildUrl() {
    const params = new URLSearchParams()
    const examId = root.dataset.examId || ''
    const lokasi = root.dataset.lokasiNama || ''
    const batch = root.dataset.batch || ''
    const sesi = root.dataset.sesi || ''
    if (examId) params.set('exam_id', examId)
    if (lokasi) params.set('lokasi_nama', lokasi)
    if (batch) params.set('batch', batch)
    if (sesi) params.set('sesi', sesi)
    const qs = params.toString()
    return qs ? `${urlBase}?${qs}` : urlBase
  }

  function fetchData(opts = {}) {
    const { isPoll = false } = opts
    return fetch(buildUrl(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((r) => r.json().catch(() => ({})).then((json) => ({ ok: r.ok, json })))
      .then(({ ok, json }) => {
        if (!ok || !json || !json.kpis) {
          if (!isPoll && statusEl) statusEl.textContent = 'Gagal memuat data.'
          return
        }
        const sig = JSON.stringify(json.kpis) + JSON.stringify(json.rows)
        if (isPoll && sig === root.dataset.lastCcSig) {
          if (statusEl) statusEl.textContent = commandCenterTimestampLabel(json.generated_at)
          return
        }
        root.dataset.lastCcSig = sig
        renderCommandCenterKpis(kpisHost, json.kpis)
        renderCommandCenterBoard(boardHost, json.rows || [])
        if (statusEl) statusEl.textContent = commandCenterTimestampLabel(json.generated_at)
      })
      .catch(() => {
        if (statusEl && !isPoll) statusEl.textContent = 'Tidak dapat menghubungi server.'
      })
  }

  if (statusEl) statusEl.textContent = commandCenterTimestampLabel()
  setInterval(() => {
    if (document.hidden) return
    fetchData({ isPoll: true })
  }, intervalMs)
}

window.initUserDutyLocationsForm = function initUserDutyLocationsForm(rootSelector) {
  const $root = rootSelector ? $(rootSelector) : $(document)
  const $wrap = $root.find('#duty-locations-wrap')
  if (!$wrap.length) return

  const $select = $root.find('#user_role_select, select[name="user[role]"]').first()

  $root.find('.select2-4').each(function () {
    const $el = $(this)
    if ($el.hasClass('select2-hidden-accessible')) {
      $el.select2('destroy')
    }
    $el.select2({ theme: 'bootstrap4' })
  })

  function toggleDutyLocations() {
    const val = $select.length ? $select.val() : ''
    const show = isPenyeliaRoleValue(val)
    $wrap.toggle(show)
    $wrap.find('.js-duty-location, #user_duty_location_ids_blank').prop('disabled', !show)
  }

  $select.off('.dutyLoc')
  $select.on('change.dutyLoc select2:select.dutyLoc select2:clear.dutyLoc', toggleDutyLocations)
  toggleDutyLocations()
}

$(() => {
  $('.select2').select2({
    theme: "bootstrap",
  });
  $('.select2-4').select2({
    theme: "bootstrap4",
  });
  initUnassignedParticipantsAjax();
  initExamSessionsTablePoll();
  initExamSessionsBulkCheckboxes();
  initExamsChartsOverview();
  initExamsParticipantsAnswersOverview();
  initCommandCenter();
  window.initUserDutyLocationsForm(document);

  $(document).on('click', '.btn-ajax', () => {
    $('#editModalBody').html('loading....');
  });
})